<template>
  <v-container>
    <v-list light>
      <template v-for="(entry, i) in entries">
        <v-list-tile :key="i" :to="entry.to">
          {{ entry.title }}
        </v-list-tile>
      </template>
    </v-list>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    entries: []
  }),
  mounted: function () {
    this.axios.get('/devotionals')
      .then((res) => {
        // There isn't necessarily a one-to-one correspondence between an item
        // in res.data and an entry for our devotional list, because res.data
        // represents devotionals and our list represents both devotionals and
        // dates. If a devotional was scheduled more than once in the time range
        // that we're allowed to access, then it must have multiple entries.

        // Prepare a date value we can compare against later
        let now = new Date()

        // Generate entries from our returned devotional data
        for (let devotional of res.data) {
          // If there are date values, we use them for the title, otherwise we
          // use the set title and devotional index
          if (devotional.datesScheduled) {
            for (let date of devotional.datesScheduled) {
              let d = this.$root.parseApiDateTimeString(date)
              // If this is the entry for today, we want to redirect back to
              // the plain /devotional page rather than specifying anything
              // after it
              let to = '/devotional/' + devotional.id
              if (d.getUTCFullYear() === now.getUTCFullYear() &&
                  d.getUTCMonth() === now.getUTCMonth() &&
                  d.getUTCDate() === now.getUTCDate()) {
                to = '/devotional'
              }
              this.entries.push({
                title: d.toLocaleDateString(),
                to,
                date
              })
            }
          } else {
            this.entries.push({
              title: devotional.setTitle + ' #' + devotional.index,
              to: '/devotional/' + devotional.id
            })
          }
        }

        // Sort the entries based on their date (or lack thereof)
        this.entries.sort((a, b) => {
          // - if a < b
          // + if a > b
          // 0 if a = b

          // We want devotionals with dates to show up first, so if 'a' has no
          // date value to compare with, we automatically sort it down
          if (typeof a.date === 'undefined') {
            return 1
            // eslint-disable-next-line
          }
          // Otherwise, we can actually try a comparison
          else {
            // If 'b' has no date, 'a' wins outright
            if (typeof b.date === 'undefined') {
              return -1
              // eslint-disable-next-line
            }
            // Otherwise, the dates decide, with newer coming first
            else {
              if (a.date < b.date) {
                return 1
              } else {
                return -1
              }
            }
          }
        })
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
